// extracted by mini-css-extract-plugin
module.exports = {"container":"SFWOverlay__container__1wMd_","portraitMobile":"SFWOverlay__portraitMobile__Txz99"};